import { render, staticRenderFns } from "./Subtitles.vue?vue&type=template&id=4d9ae6f6&lang=pug&"
import script from "./Subtitles.vue?vue&type=script&lang=ts&"
export * from "./Subtitles.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports